/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SignatureApproverV1Dto = {
  /**
   * Approver id
   */
  id: string;
  /**
   * Approval status
   */
  status: SignatureApproverV1Dto.status;
};
export namespace SignatureApproverV1Dto {
  /**
   * Approval status
   */
  export enum status {
    APPROVED = 'approved',
    INITIATED = 'initiated',
    NOTIFIED = 'notified',
    REJECTED = 'rejected',
  }
}
